module.exports = __webpack_public_path__ + "static/sport/img-right.e75e744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-right.png
// module id = S0K2
// module chunks = 0